import React from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'colorVariant',
})(({ theme, variant = 'contained', colorVariant = 'default' }) => ({
  // 호버 효과를 위한 공통 설정
  position: 'relative',
  overflow: 'hidden',

  // 기본 스타일
  ...theme.typography.body1,
  fontWeight: 'medium',
  padding: '16px 24px',
  border: 'none',
  borderRadius: '4px',
  boxShadow: 'none',

  // 호버 효과를 위한 가상 요소
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.action.hover,
    opacity: 0,
  },

  // contained variant - 검정
  ...(variant === 'contained' &&
    colorVariant === 'default' && {
      backgroundColor: 'var(--pp-button-primary-bg)',
      color: 'var(--pp-button-primary-fg)',
      '&&': {
        backgroundColor: 'var(--pp-button-primary-bg)',
        color: 'var(--pp-button-primary-fg)',
      },
      '&:hover': {
        backgroundColor: 'var(--pp-button-primary-bg)',
        boxShadow: 'none',
        '&::before': {
          opacity: 1,
        },
      },
    }),

  // contained variant - 주황
  ...(variant === 'contained' &&
    colorVariant === 'accent' && {
      backgroundColor: '#f98631',
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: '#f98631',
        boxShadow: 'none',
        '&::before': {
          opacity: 1,
        },
      },
    }),

  // outlined variant
  ...(variant === 'outlined' && {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.grey.line}`,
    color: theme.palette.black[9],
    '&:hover': {
      backgroundColor: theme.palette.background.paper,
      borderColor: theme.palette.grey.line,
      color: theme.palette.black[9],
    },
  }),

  // Disabled state
  '&.Mui-disabled': {
    backgroundColor: theme.palette.grey.line,
    color: theme.palette.black[1],
    borderColor: theme.palette.grey.line,
  },
  '&&.Mui-disabled': {
    backgroundColor: theme.palette.grey.line,
    color: theme.palette.black[1],
    borderColor: theme.palette.grey.line,
  },
}));

const BasicButton = ({
  children,
  variant = 'contained',
  colorVariant = 'default',
  startIcon,
  endIcon,
  fullWidth,
  disabled,
  disableRipple = true,
  onClick,
  ...props
}) => {
  return (
    <StyledButton
      variant={variant}
      colorVariant={colorVariant}
      startIcon={startIcon}
      endIcon={endIcon}
      fullWidth={fullWidth}
      disabled={disabled}
      onClick={onClick}
      disableRipple={disableRipple}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default BasicButton;
